import getAssetsUrl from '../accessors/get-assets-url';

const removeAssetUrl = (src) => {
  const assetUrl = getAssetsUrl();

  return src.replace(assetUrl, '/');
};

export default removeAssetUrl;
